'use client';

import {useEffect} from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export const HeaderHeightObserver = () => {
  useEffect(() => {
    const header = document.querySelector('header');

    const resizeObserver = new ResizeObserver((entries) => {
      document.documentElement.style.setProperty(
        '--header-height',
        `${entries[0].contentRect.height}px`,
      );
    });

    header && resizeObserver.observe(header);

    return () => {
      header && resizeObserver.unobserve(header);
    };
  }, []);

  return null;
};
